import { useState, useRef, useContext } from "react";

import GlobalContext from "../../isp._comun/iu/contexto/GlobalContext";
import CrearHandlerDeErroresComunesDeComando from "../../isp._comun/iu/componentes/CrearHandlerDeErroresComunesDeComando";
import * as TipoDeError from "../../isp._comun/services/Errores";
// import useHandlerDeComando from '../../isp._comun/iu/componentes/archivo/useHandlerDeComando'
import ServicioDeLogin from "../../isp.žapi.idyacceso/ServicioDeLogin";
import PantallaLoginLayout from "./layouts/PantallaLoginLayout";
// import login from "../../servicios/login";
// import * as Evento from "../../../comun/Eventos";
// import { NotificacionToastDeError } from "../../../_comun/componentes/widgets/Notificaciones";
// import CodigoDeError from "../../../_comun/CodigosDeErrorDeRespuestas.json";
// import DataRespuestas from "../../../_comun/DataEstaticaDeRespuestas.json";

const PantallaLogin = ({ cargarPantallaPrincipal }) => {
    // const [evaluacion, setEvaluacion] = useState(null);
    const [nombreUsuario, setNombreUsuario] = useState("");
    const [contraseña, setContraseña] = useState("");
    const [loading, setLoading] = useState(false);

    const [banderasError, setBanderasError] = useState({
        usuNoVal: false,
        nomVacio: false,
        contraVacia: false,
    });

    const refPantallaLoguinLayout = useRef(null);
    // const [evaluacion, setEvaluacion] = useState({clienteNoValido:false, usuarioVacio:false, contraseñaVacia:false});
    //console.log("entro presentador logueo?")
    const notificar = function (notificacion) {
        refPantallaLoguinLayout.current.notificar(notificacion);
    };

    const handleErroresComunesDeComando = CrearHandlerDeErroresComunesDeComando(notificar);

    const manejarLogueo = async () => {
        // const manejarLogueo = useHandlerDeComando ( async () => {
        setLoading(true);

        try {
            const usuario = await new ServicioDeLogin().ejecutar({
                nombreUsuario,
                contraseña,
            });
            cargarPantallaPrincipal(usuario);
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                const nuevoEstado = JSON.parse(JSON.stringify(banderasError));
                for (const property in nuevoEstado) {
                    nuevoEstado[property] = false;
                }

                error.data.errores.forEach((error) => {
                    nuevoEstado[error.key] = true;
                });

                setLoading(false);
                setBanderasError(nuevoEstado);
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                setLoading(false);
                setBanderasError({
                    usuNoVal: false,
                    nomVacio: false,
                    contraVacia: false,
                    // errorServidor: true,
                });

                // throw error;
                /* let nombreDeError = error.constructor.name;
                refPantallaLoguin.current.notificar(
                    new NotificacionToastDeError(
                        DataRespuestas[nombreDeError].titulo,
                        DataRespuestas.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataRespuestas[nombreDeError].descripcion
                    )
                ); */
                // return;
            }
            try {
                handleErroresComunesDeComando(error);
            } catch (error) {
                //asert no debe pasar esto
            }
        }
    };
    // });

    const setearNombreUsuario = (nombreUsuario) => {
        setNombreUsuario(nombreUsuario);
        // setBanderasError({ ...banderasError, usuarioVacio: false });
    };
    const setearContraseña = (contraseña) => {
        setContraseña(contraseña);
        // setBanderasError({ ...banderasError, contraseñaVacia: false });
    };

    const values = useContext(GlobalContext);
    values.notificar = notificar;

    return (
        <PantallaLoginLayout
            nombreUsuario={nombreUsuario}
            contraseña={contraseña}
            loading={loading}
            banderasError={banderasError}
            setearNombreUsuario={setearNombreUsuario}
            setearContraseña={setearContraseña}
            manejarLogueo={manejarLogueo}
            // manejarLogueo={useHandlerDeComando(manejarLogueo)}
            ref={refPantallaLoguinLayout}
        />
    );
};

export default PantallaLogin;
